import { useEffect } from 'react'

const useOverflowDebuggerInDev = (isDebug = false) => {
  useEffect(() => {
    if (!isDebug) {
      return
    }
    let mousetrapRef: Mousetrap.MousetrapInstance | undefined = undefined
    import('mousetrap').then(({ default: mousetrap }) => {
      mousetrapRef = mousetrap.bind(['command+i', 'ctrl+i', 'alt+i'], () => {
        document.body.classList.toggle('inspect')
      })
    })

    return () => {
      mousetrapRef?.unbind(['command+i', 'ctrl+i', 'alt+i'])
    }
  }, [])
}

export default useOverflowDebuggerInDev
